import classNames from "classnames";

export const TopPlaceFrame = ({ children, placeId }) => {
    return (
        <div 
            id={`place_${placeId}`}
            className={classNames({
                'rounded-2xl md:rounded-none bg-white md:bg-transparent overflow-hidden': true,
                'border border-zinc-200 md:border-none': true,
        })}>
            {children}
        </div>
    );
};